module.exports = __webpack_public_path__ + "img/dev-null-the-blog.6b7a2007.png";